import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/tickets' // old
const newResource = '/integrations/mobly/services/cs/tickets' // new

const create = (payload, organization) => AxiosClient.post(
  resource, payload, { headers: { organization } }
)

const find = (queryParams = '', organization) => AxiosClient.get(
  `${newResource}?${queryParams}`, { headers: { organization } }
)

const findOne = (ticketId, queryParams = '', organization) => AxiosClient.get(
  `${newResource}/${ticketId}?${queryParams}`, { headers: { organization } }
)

const findTicketTasks = (ticketId, queryParams = '', organization) => AxiosClient.get(
  `${resource}/${ticketId}/ticketTasks?${queryParams}`, { headers: { organization } }
)

const update = (payload, ticketId, organization) => AxiosClient.patch(
  `${resource}/${ticketId}`, payload, { headers: { organization } }
)

const history = (ticketId, organization) => AxiosClient.get(
  `${newResource}/${ticketId}/history`, { headers: { organization } }
)

const generateReportEmails = (ticketId, payload, organization) => AxiosClient.post(
  `${newResource}/${ticketId}/comments/generateReportEmails`, payload, { headers: { organization } }
)

export {
  create,
  find,
  findOne,
  findTicketTasks,
  update,
  history,
  generateReportEmails
}
